module.exports = __webpack_public_path__ + "img/PAG310&313_.3326f6a6.png";